<template>
  <PropertyDetailsCardRows>
    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.propertyType"
      label="Property type"
      icon="home-03"
      :value="property?.specifications.propertyType"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.location?.apartmentNumber"
      label="Apartment number"
      icon="door-01"
      :value="property?.location?.apartmentNumber"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.architectureStyle"
      label="Architecture style"
      icon="building-columns"
      :value="property?.specifications.architectureStyle"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.yearBuilt"
      label="Year built"
      icon="calendar"
      :value="property?.specifications.yearBuilt"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.numberOfFloors"
      label="Total number of floors"
      icon="layers-three-01"
      :value="property?.specifications.numberOfFloors"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.apartmentFloor"
      label="Apartment floor"
      icon="stairs"
      :value="property?.specifications.apartmentFloor"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.squareFeet"
      label="Size"
      icon="ruler"
      :value="`${property?.specifications?.squareFeet} ft`"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.bedrooms"
      label="Bedrooms"
      icon="bed-double"
      :value="property?.specifications.bedrooms"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.fullBathrooms"
      label="Full bathrooms"
      icon="bath"
      :value="property?.specifications.fullBathrooms"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.specifications?.halfBathrooms"
      label="Half Bathrooms"
      icon="bath"
      :value="property?.specifications.halfBathrooms"
    />
  </PropertyDetailsCardRows>
</template>

<script setup lang="ts">
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

defineProps<{
  property: PropertyDto | null | undefined;
}>();
</script>
